import React from 'react';
import School from '../School';
import { NavBar, Space, Popover, Dialog } from 'antd-mobile';
import { MoreOutline } from 'antd-mobile-icons';
import { useTonConnectUI, useTonWallet } from '@tonconnect/ui-react';
import { useNavigate } from 'react-router-dom';
import schools from '../../db/schools.json';
import { localizeSchool } from '../../db/localizeSchool';
import { useT } from '../../i18n';


function SchoolList() {
    const [tonConnectUI] = useTonConnectUI();
    const wallet = useTonWallet();
    const navigate = useNavigate();
    const { locale, t } = useT();

    const actions = wallet
        ? [{ key: 'disconnect', icon: <div />, text: t('disconnect_wallet') }]
        : [];

    const right = (
        <Space style={{ '--gap': '12px' }}>
            <button
                type="button"
                onClick={() => navigate('/me')}
                style={{
                    background: 'none',
                    border: 'none',
                    cursor: 'pointer',
                    fontSize: 14,
                    padding: 0,
                }}
            >
                {t('my_donations')}
            </button>
            {wallet && (
                <Popover.Menu
                    actions={actions}
                    placement="bottom-start"
                    onAction={(node) => {
                        if (node.key === 'disconnect') {
                            Dialog.confirm({
                                cancelText: t('cancel'),
                                confirmText: t('disconnect'),
                                title: t('logout_title'),
                                content: t('logout_body'),
                                onConfirm: async () => {
                                    await tonConnectUI.disconnect();
                                },
                            });
                        }
                    }}
                    trigger="click"
                >
                    <MoreOutline />
                </Popover.Menu>
            )}
        </Space>
    );

    return (
        <>
            <NavBar backArrow={<div />} right={right}>
                {t('school_donations')}
            </NavBar>
            <div className="cards__container">
                {schools.map((school) => {
                    return <School school={localizeSchool(school, locale)} key={school.id} />;
                })}
            </div>
        </>
    );
}

export default SchoolList;
